import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { BYPASS_INTERCEPTOR_ERROR_NOTIFICATIONS } from '../tokens/http.context.tokens';

export const genericErrorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService)
  return next(req).pipe(
    catchError((err: any) => {
       // Check the HttpContext for the bypass token
      const bypassInterceptor = req.context.get(BYPASS_INTERCEPTOR_ERROR_NOTIFICATIONS);

      if (!bypassInterceptor) {
        if (err instanceof HttpErrorResponse) {
          // Handle HTTP errors
          if (err.status === 401) {
            // Specific handling for unauthorized errors
            toastr.error(`Unauthorized request`);
            // You might trigger a re-authentication flow or redirect the user here
          } else if (err.status === 400) {
          // Specific handling for bad requests
          toastr.warning(`An error occurred: ${err.error.detail}`);
        } else {
            // Handle other HTTP error codes
            toastr.error(`${err.error.detail}`);
          }
        } else {
          // Handle non-HTTP errors, TO DO change text later
        }
      }
      // Re-throw the error to propagate it further
      return throwError(() => err);
    })
  );
};
